import * as actionTypes from '../../action/addemail/AddEmail'

const initialState = {
    error: false,
    isFetching: false,
    errormessage: ''
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_EMAILTEMPLATE_FETCH:
            return {
                ...state,
                isFetching: true
            };
        case actionTypes.GET_EMAILTEMPLATE_SUCCESS :
            return {
                ...state,
                isFetching: false,
                error: false,
                email: action.payload
            };
        
        case actionTypes.GET_EMAILTEMPLATE_FAILURE :
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_EMAILTEMPLATE_MESSAGE:
            return {
                ...state,
                isFetching: false,
                error: false,
                errormessage: action.payload
            };
        
        default:
            return state;
    }
}

export default reducer;